import { atom, selector } from "recoil";
import { getCustomerSettings } from "../CustomerSettings";

export const csLegendVisibleState = atom({
  key: 'csLegendVisibleState',
  default: selector({
    key: 'csLegendVisibleStateSelector',
    get: () => {
      return getCustomerSettings("mapConfig.CROSSSECTION_LEGEND");
    }
  })
});

export const csLegendListState = atom({
  key: 'csLegendListState',
  default: [],
  dangerouslyAllowMutability: true
});

export const csSelectedLegendState = atom({
  key: 'csSelectedLegendState',
  default: undefined
});

export const addCsLegendSelector = selector({
  key: 'addCsLegendSelector',
  set: ({get, set}, legend) => {
    const oldList = get(csLegendListState);
    const idx = oldList.findIndex(target => {
      return target.id === legend.id;
    });
    if (idx !== -1) return;
    const newList = [...oldList, legend];
    set(csLegendListState, newList);
    set(csSelectedLegendState, newList.length - 1);
  },
  get: () => {},
  dangerouslyAllowMutability: true
});

export const removeCsLegendSelector = selector({
  key: 'removeCsLegendSelector',
  set: ({get, set}, legend) => {
    const oldList = get(csLegendListState);
    const idx = oldList.findIndex(target => {
      return target.id === legend.id;
    });
    if (idx === -1) return;

    let activeTabIdx;
    if (oldList[idx - 1]) {
      activeTabIdx = idx - 1;
    } else if (oldList[idx + 1]) {
      activeTabIdx = idx;
    } else {
      activeTabIdx = 0;
    }
    const newList = [...oldList.slice(0, idx), ...oldList.slice(idx + 1)];
    set(csLegendListState, newList);
    set(csSelectedLegendState, activeTabIdx);
  },
  get: () => {},
  dangerouslyAllowMutability: true
});

export const draggingCsLegendState = atom({
  key: 'draggingCsLegendState',
  default: false
});

export const csLegendPanelPosition = atom({
  key: 'csLegendPanelPosition',
  default: {x: 0, y: 0}
});
